import "./FooterStyles.css";

import React from "react";
import {
  FaFacebook,
  FaGithub,
  FaHome,
  FaMailBulk,
  FaPhone,
  FaTwitter,
} from "react-icons/fa";
import { Link } from "react-router-dom/dist";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-container">
        <div className="left">
          <div className="location">
            <FaHome size={30} style={{ color: "white", marginRight: "2rem" }} />
            <div>
              <p>House no. 9, Wallfort Panaroma</p>
              <p>Boriakurud</p>
              <p>Raipur (C.G)</p>
            </div>
          </div>
          <div className="phone">
            <FaPhone
              size={30}
              style={{ color: "white", marginRight: "2rem" }}
            />
            <p>+91-9755860299 </p>
          </div>
          <div className="mail">
            <FaMailBulk
              size={30}
              style={{ color: "white", marginRight: "2rem" }}
            />
            <p>simunbiswas14395@gmail.com </p>
          </div>
        </div>
        <div className="right">
          <h1>About</h1>
          <p>
            this website is a responsive website coded to deal with various
            design challenges.
          </p>
          <div className="social">
            <Link to={"https://www.facebook.com/simun.bepari"}>
              <FaFacebook
                size={20}
                style={{ color: "white", marginRight: "1rem" }}
              />
            </Link>
            <Link to={"https://twitter.com/SimunBepari"}>
              <FaTwitter
                size={20}
                style={{ color: "white", marginRight: "1rem" }}
              />
            </Link>

            <Link to={"https://github.com/SimunBiswas"}>
              <FaGithub
                size={20}
                style={{ color: "white", marginRight: "1rem" }}
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
